/* eslint-disable react/jsx-props-no-spreading */
import { useIsVisible } from '@folklore/hooks';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useEffect } from 'react';

import { useSubscribed } from '../../hooks/useSubscription';

import { useMatchedPromotions } from '../../contexts/PromotionsContext';
import PromotionSubscriptionCard from '../cards/PromotionSubscriptionCard';

import styles from '../../styles/blocks/subscription-block.module.css';
import { useTracking } from '@folklore/tracking';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

function SubscriptionBlock({ className, ...props }) {
    const matchedPromotions = useMatchedPromotions();
    const [currentPromotion = null] = matchedPromotions.filter(
        ({ type, placement }) => type === 'subscription' && placement === 'block',
    );
    const subscribed = useSubscribed(
        currentPromotion !== null ? currentPromotion.subscription : null,
    );
    const { ref: refVisible, visible } = useIsVisible({
        persist: true,
    });
    const tracking = useTracking();
    useEffect(() => {
        if (visible && currentPromotion !== null) {
            tracking.trackPromotion(currentPromotion, 'impression');
        }
    }, [currentPromotion, visible]);
    if (subscribed || currentPromotion === null) {
        return null;
    }
    return (
        <div className={classNames([styles.container, className])} ref={refVisible}>
            <PromotionSubscriptionCard
                {...currentPromotion}
                {...props}
                className={styles.card}
                innerClassName={styles.inner}
            />
        </div>
    );
}

SubscriptionBlock.propTypes = propTypes;
SubscriptionBlock.defaultProps = defaultProps;

export default SubscriptionBlock;
